import { getController } from '@/services/service'

const url = 'emails'

export const emailService = {
	...getController<Api.Email, Api.EmailPostInput>(url),
}

export default emailService
